// extracted by mini-css-extract-plugin
export default {"list":"coupon-list_list__OcIjB","item":"coupon-list_item__sOjQz","mt-5":"coupon-list_mt-5__FVfmQ","btn":"coupon-list_btn__FIgT-"};